import { render, staticRenderFns } from "./IsOrtakligi.vue?vue&type=template&id=6aadbfce&scoped=true&"
import script from "./IsOrtakligi.vue?vue&type=script&lang=js&"
export * from "./IsOrtakligi.vue?vue&type=script&lang=js&"
import style0 from "./IsOrtakligi.vue?vue&type=style&index=0&id=6aadbfce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aadbfce",
  null
  
)

export default component.exports